import { Pagination, Stack, Typography, useMediaQuery } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { IPaginationBaseState } from 'react-jhipster';
import { useTheme } from '@mui/material/styles';

interface PaginationProps<T> {
  paginationState: IPaginationBaseState;
  totalItems: number;
  list: readonly T[];
  onChange: (event: React.ChangeEvent, page: number) => void;
}

export const PaginationComponent: React.FC<PaginationProps<any>> = ({ paginationState, totalItems, onChange, list }) => {
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const siblingCount = isXsScreen ? -1 : 1;

  return (
    <>
      {totalItems ? (
        <Box display={list && list.length > 0 ? 'block' : 'none'} marginTop="20px">
          <Stack direction="row" justifyContent="end" alignItems="center">
            <Box>
              <Typography color="text.secondary" textAlign="center">
                {paginationState.activePage * paginationState.itemsPerPage - paginationState.itemsPerPage + 1}-
                {Math.min(paginationState.activePage * paginationState.itemsPerPage, totalItems)} de {totalItems} resultados
              </Typography>
              <Pagination
                count={Math.ceil(totalItems / paginationState.itemsPerPage)}
                page={paginationState.activePage}
                onChange={onChange}
                defaultPage={1}
                siblingCount={siblingCount}
                color="secondary"
                size={isXsScreen ? 'medium' : 'large'}
              />
            </Box>
          </Stack>
        </Box>
      ) : (
        ''
      )}
    </>
  );
};
